import { render, staticRenderFns } from "./MailWindow.vue?vue&type=template&id=5bbbb75c&"
import script from "./MailWindow.vue?vue&type=script&lang=js&"
export * from "./MailWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports